import { render } from "./classroomPractice.vue?vue&type=template&id=79df5fba&scoped=true"
import script from "./classroomPractice.vue?vue&type=script&lang=js"
export * from "./classroomPractice.vue?vue&type=script&lang=js"

import "./classroomPractice.vue?vue&type=style&index=0&id=79df5fba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79df5fba"]])

export default __exports__